import { useCallback } from 'react';

import { useRecoilState } from 'recoil';
import { setRecoil } from 'recoil-nexus';

import { dockState } from './dockState';

// Upsert by id — merge onto a matching widget rather than duplicating it.
const upsertItem = (items, item) => {
  if (items.some((it) => it.id === item.id)) {
    return items.map((it) => (it.id === item.id ? { ...it, ...item } : it));
  }
  return [...items, { side: 'right', minimized: false, ...item }];
};

const removeItem = (items, id) => items.filter((it) => it.id !== id);

export const openDock = (item) => {
  setRecoil(dockState, (state) => ({ ...state, items: upsertItem(state.items, item) }));
};

export const closeDock = (id) => {
  setRecoil(dockState, (state) => ({ ...state, items: removeItem(state.items, id) }));
};

// In-component API for the same operations.
export const useDock = () => {
  const [state, setState] = useRecoilState(dockState);

  const open = useCallback(
    (item) => setState((prev) => ({ ...prev, items: upsertItem(prev.items, item) })),
    [setState]
  );

  const close = useCallback(
    (id) => setState((prev) => ({ ...prev, items: removeItem(prev.items, id) })),
    [setState]
  );

  const update = useCallback(
    (id, patch) =>
      setState((prev) => ({
        ...prev,
        items: prev.items.map((it) => (it.id === id ? { ...it, ...patch } : it))
      })),
    [setState]
  );

  const minimize = useCallback((id, minimized = true) => update(id, { minimized }), [update]);

  return { items: state.items, open, close, update, minimize };
};
